import React from 'react';
import Layout from '../components/Layout';
import Reveal, { SplitWords } from '../components/Reveal';

/**
 * @author Nelson
 */
const DeleteAccount = () => (
    <Layout title="Account Deletion Policy" pad="plain">
        <header className="page__head">
            <h1 className="page__title page__title--display">
                <SplitWords text="Account Deletion Policy" start={120} />
            </h1>
        </header>

        <div className="prose">
            <Reveal as="p" delay={420}>
                Thank you for using the YUAN app. Currently, we do not support direct account deletion through the app or website.
            </Reveal>
            <Reveal as="p" delay={490}>
                Our system is designed for anonymous login through email-based OTP verification only. We do not collect or store
                any personal identifiable information beyond your email address.
            </Reveal>
            <Reveal as="p" delay={560}>
                If you would like to deactivate your access or have concerns about your data, please contact us at{' '}
                <a className="u-link" href="mailto:sp.yuanlab@gmail.com">sp.yuanlab@gmail.com</a>
            </Reveal>
        </div>
    </Layout>
);

export default DeleteAccount;
